export default {
  expanded: true,
  developerEnabled: false,
  debugApi: false,
  showPermissions: false,
  showRequests: false,
  showResponses: false,
  logLevel: 'error'
};
